
<script>
import {inView, scrollTo} from '@/common/util';
import transitionFade from '@/components/transition/fade';
import { pick } from 'lodash';
import store from '../store/index.js';

export default {
	data() {
		return {
			show: false,
			submit: null,
			form: null
		};
	},
	created() {
		window.addEventListener('scroll', () => {
			this.update();
		});
	},
	computed: {
		isShowCoupon() {
			return store.isShowCoupon;
		},
		couponValue() {
            return store.couponValue;
        }
	},
	methods: {
		getSubmit() {
			if (this.submit) {
				return this.submit;
			}
			this.submit = document.querySelector('#submit');
			return this.submit;
		},
		getForm() {
			if (this.form) {
				return this.form;
			}
			this.form = document.querySelector('#form');
			return this.form;
		},
		update() {
			if (this.inView(this.getSubmit())) {
				this.show = false;
				return;
			}
			this.show = true;
		},
		inView(el) {
			const rect = pick(el.getBoundingClientRect(), ['top', 'bottom', 'left', 'right', 'width', 'height']);
			const clientHeight = document.documentElement.clientHeight;
			const clientWidth = document.documentElement.clientWidth;
			rect.bottom = clientHeight - rect.bottom;
			rect.right = clientWidth - rect.right;
			if (
				(rect.top) > 0 &&
				(rect.bottom) > 0 &&
				(rect.width + rect.left > 0) &&
				(rect.width + rect.right > 0)
			) {
				return true;
			}
			return false;
	},
		toForm() {
			const scrollTop = document.documentElement.scrollTop;
			const clientHeight = document.documentElement.clientHeight;
			const formHeight = this.getForm().offsetHeight;
			const formTop = this.getForm().getBoundingClientRect().top;
			scrollTo(scrollTop + formTop - ((clientHeight - formHeight) / 2), 100);

			this.$eventBus.$emit('toSubmit', 'fixed-button-click');
		},
		click() {
			this.toForm();
		}
	},
	mounted() {
		this.update();
	},
	components: {
		transitionFade
	}
}
</script>

<template>
	<transition-fade>
		<div class="footer-submit" v-if="show" @click="click">
			<div v-show="isShowCoupon">
				<p class="footer-submit-text">免费预约咨询</p>
				<p class="footer-submit-sub">送{{couponValue}}元到店打车券</p>
			</div>
			<div v-show="!isShowCoupon">
				<p class="footer-submit-text-center">免费预约咨询</p>
			</div>
			<i></i>
			<i></i>
			<i></i>
		</div>
	</transition-fade>
</template>
<style lang="stylus" scoped>
.footer-submit
	position fixed
	left 0
	right 0
	bottom 0
	margin 0 auto
	max-width 20rem
	width 100%
	height 3.15rem
	font-family PingFangSC-Semibold,PingFang SC
	background linear-gradient(144deg,rgba(250,217,97,1) 0%,rgba(247,107,28,1) 100%);
	text-align center
	color #fff
	font-size 1.07rem
	font-weight 600
	overflow hidden
	z-index 10
	.footer-submit-text
		font-size:1.07rem;
		padding-top .35rem;
	.footer-submit-sub
		font-size:0.75rem;
	.footer-submit-text-center
		line-height 3.15rem;
</style>